const initialState = {
  activeTab: 'dashboard',
  availableCharts: [],
  retrieveChartBegin: false,
  retrieveChartError: false,
  retrieveChartDataBegin: false,
  retrieveChartDataSuccess: null,
  retrieveChartDataFailure: null,
  retrieveTopicsdropdownBegin: true,
  retrieveTopicsdropdownSuccess: false,
  retrieveTopicsdropdownError: false,
  updateTopicsdropdownBegin: true,
  updateTopicsdropdownSuccess: false,
  updateTopicsdropdownError: false,
  topicDropdown: [],
  chart100: [],
  chart101: [],
  chart102: [],
  chart103: [],
  chart104: [],
  chart105: [],
  chart106: [],
  chart107: [],
  chart108: [],
  chart109: [],
  chart110: [],
  chart111: [],
  chart112: [],
  chart113: [],
  chart114: [],
  chart115: [],
  chart116: [],
  chart117: [],
  chart118: [],
  chart119: [],
  chart120: [],
  chart121: [],
  chart124: [],
  chart125: [],
  updateChartBegin: false,
  updateChartSuccess: false,
  updatedChartId: {},

  retrieveCategoriesBegin: false,
  retrieveCategoriesSuccess: false,
  retrieveCategoriesFailure: false,
  allCategories: [],

  updateSelectedTopicBegin: false,
  updateSelectedTopicSuccess: false,
  updateSelectedTopicFailure: false,

  retrieveCommentsBegin: false,
  retrieveCommentsSuccess: false,
  retrieveCommentsFailure: false,
  allComments: {},

  retrieveUploadedCommentsBegin: false,
  retrieveUploadedCommentsSuccess: false,
  retrieveUploadedCommentsFailure: false,
  allUploadedComments: {},

  allSources: [],

  retrieveFeedsBegin: false,
  retrieveFeedsSuccess: false,
  retrieveFeedsFailure: false,
  updateFeedsRelevantBegin: false,
  updateFeedsRelevantSuccess: false,
  updateFeedsRelevantFailure: false,
  allFeeds: {},

  retrieveTweetsBegin: false,
  retrieveTweetsSuccess: false,
  retrieveTweetsFailure: false,
  updateTweetsRelevantBegin: false,
  updateTweetsRelevantSuccess: false,
  updateTweetsRelevantFailure: false,
  updateTweetsIsSarcasmManuallyToggledBegin: false,
  updateTweetsIsSarcasmManuallyToggledSuccess: false,
  updateTweetsIsSarcasmManuallyToggledFailure: false,
  allTweets: {},

  retrieveHeadlinesBegin: false,
  retrieveHeadlinesSuccess: false,
  retrieveHeadlinesFailure: false,
  updateHeadlinesRelevantBegin: false,
  updateHeadlinesRelevantSuccess: false,
  updateHeadlinesRelevantFailure: false,
  allHeadlines: {},

  updateCommentsRelevantBegin: false,
  updateCommentsRelevantSuccess: false,
  updateCommentsRelevantFailure: false,
  updateCrawledCommentsIsSarcasmManuallyToggledBegin: false,
  updateCrawledCommentsIsSarcasmManuallyToggledSuccess: false,
  updateCrawledCommentsIsSarcasmManuallyToggledFailure: false,

  updateUploadedCommentsRelevantBegin: false,
  updateUploadedCommentsRelevantSuccess: false,
  updateUploadedCommentsRelevantFailure: false,
  updateUploadedCommentsIsSarcasmManuallyToggledBegin: false,
  updateUploadedCommentsIsSarcasmManuallyToggledSuccess: false,
  updateUploadedCommentsIsSarcasmManuallyToggledFailure: false,

  retrieveActiveTopicBegin: false,
  retrieveActiveTopicFailure: false,
  retrieveActiveTopicSucess: false,
  retrieveActiveTopicLastSuccessfulTopic: [],
  activeTopic: [],

  retrieveShareReportStatusBegin: false,
  retrieveShareReportStatusSuccess: false,
  retrieveShareReportStatusError: false,
  shareReportStatus: false,

  sendShareReportBegin: true,
  sendShareReportSuccess: false,
  sendShareReportError: false,
  activeTopicCompareData: {},
  topicCompareData: [],
  selectedTopicName: [],
  retrieve_compare_begin: false,
  retrieve_compare_success: false,
  retrieve_compare_error: false,

  updateChartFailure: false,
  headerTopicData: {},
  retrieveFeedsDetailsBegin: true,
  retrieveFeedsDetailsSuccess: false,
  retrieveFeedsDetailsFailure: false,
  feedDetails: {},

  commentOrTweetAfterRelevanceUpdates: null,
  postAfterRelevanceUpdates: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js